import * as React from 'react'
import { format, formatISO } from 'date-fns'
import { Calendar as CalendarIcon } from 'lucide-react'

import { cn } from '@/helpers/utils'
import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover'

const DatePicker = ({ onChange, value, ...rest }) => {
  const [date, setDate] = React.useState(value)
  const [open, setOpen] = React.useState(false)

  const handleDateChange = (newDate) => {
    setDate(newDate)
    setOpen(false)
    // send a string representation of the date out of the component
    // we do this to normalize the timezone issue, otherwise it's off by 1 day due to timezones
    // might need to come up with a better solution in the future
    onChange?.(formatISO(newDate))
  }

  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <Button
          variant='outline'
          className={cn(
            'w-full justify-start text-left font-normal',
            !date && 'text-muted-foreground'
          )}
        >
          <CalendarIcon className='mr-2 h-4 w-4' />
          {date ? format(date, 'PPP') : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-auto p-0'>
        <Calendar
          mode='single'
          selected={date}
          onSelect={handleDateChange}
        />
      </PopoverContent>
    </Popover>
  )
}

export default DatePicker
